<template>
  <div class="school-notice-board">
    <div v-if="error">
      {{ error }}
      <Spinner />
    </div>
    <div
      v-if="myData.length"
      class="layout"
    >
      <br>
      <ListOfAnnouncements :announcements="myData" />
    </div>
    <div
      v-else
      class="card"
    >
      <p>No announcements at the moment, check back later</p>
      <Spinner />
    </div>
  </div>
</template>

<script>
import getPosts from '@/composables/getPosts'

// component imports
import ListOfAnnouncements from '@/components/ListOfAnnouncements.vue'
import Spinner from '@/components/Spinner.vue'

export default {
  name: 'Announcements',
  components: { ListOfAnnouncements, Spinner },
  setup () {
    const { myData, error, load } = getPosts()

    load('announcements')

    return { myData, error }
  }
}
</script>

<style>
  .school-notice-board {
    max-width: 960px;
    margin: 0 auto;
    padding: 0;
  }
</style>
